{
  "version": "1.2.6",
  "objects": {
    "7536295121011597692": {
      "type": "frame",
      "id": "7536295121011597692",
      "z": 11787,
      "textContent": "",
      "left": 1762.5412692762416,
      "top": 1216.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.5199371001040592,
      "scaleY": 0.9345156565051169,
      "fill": "#FCF2F6",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121012314220": {
      "type": "frame",
      "id": "7536295121012314220",
      "z": 10640,
      "textContent": "",
      "left": 1762.5412692762416,
      "top": 1216.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.5199371001040592,
      "scaleY": 0.128,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295121011597692",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121014968355": {
      "type": "frame",
      "id": "7536295121014968355",
      "z": 10641,
      "textContent": "",
      "left": 2123.2976710948724,
      "top": 1242.0679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.17601241378096846,
      "scaleY": 0.048,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295121012314220",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a11jD",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295121013286152": {
      "type": "wireframe",
      "id": "7536295121013286152",
      "z": 10642,
      "top": 1242.0679833992392,
      "left": 2123.2976710948724,
      "width": 141.482421875,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295121014968355",
      "layoutPosition": "a05sg",
      "wireframeName": "button",
      "fill": "#FFFFFF",
      "textColor": "#808080",
      "style": "roundFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Restaurants",
        "iconLeft": { "prefix": "fas", "iconName": "utensils" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7536295121007150538": {
      "type": "wireframe",
      "id": "7536295121007150538",
      "z": 10643,
      "top": 1242.0679833992392,
      "left": 2239.4094875011224,
      "width": 105.6826171875,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295121014968355",
      "layoutPosition": "a1B2a",
      "wireframeName": "button",
      "fill": "#FFFFFF",
      "textColor": "#808080",
      "style": "roundFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Hotels",
        "iconLeft": { "prefix": "fas", "iconName": "bed" },
        "iconRight": null
      }
    },
    "7536295121009205227": {
      "type": "wireframe",
      "id": "7536295121009205227",
      "z": 10650,
      "top": 1237.0679833992392,
      "left": 1782.5412692762416,
      "width": 202.0042136050174,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7536295121012314220",
      "layoutPosition": "a11gVaQL",
      "wireframeName": "searchBar",
      "fill": "#CBCBCB",
      "itemsData": {
        "7534871020698110268": {
          "id": "7534871020698110268",
          "value": "Item",
          "item_position": 2000000
        },
        "7534871020700038855": {
          "id": "7534871020700038855",
          "value": "Item",
          "item_position": 1000000
        },
        "7534871020707312503": {
          "id": "7534871020707312503",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#000000",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Find a location...",
        "iconLeft": null,
        "iconRight": { "prefix": "fas", "iconName": "magnifying-glass" }
      },
      "setDimension": true
    },
    "7536295121015152423": {
      "type": "frame",
      "id": "7536295121015152423",
      "z": 10644,
      "textContent": "",
      "left": 1762.5412692762416,
      "top": 1296.5679833992392,
      "width": 1110,
      "height": 625,
      "scaleX": 0.5199371001040592,
      "scaleY": 0.6129156565051168,
      "fill": "transparent",
      "opacity": 0.2,
      "container": "7536295121011597692",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a12ZC",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 2,
      "layoutPadding": 2,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121011654221": {
      "type": "shape",
      "id": "7536295121011654221",
      "z": 11017,
      "shapeName": "icon",
      "textContent": "",
      "left": 1974.3105704127145,
      "top": 1419.6745354603947,
      "width": 100,
      "height": 88.88888888888889,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.5059157884256011,
      "scaleY": 1.5059157884256011,
      "stroke": "#A35D4C",
      "strokeWidth": 3,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "transparent",
      "angle": 0,
      "container": "7536295121015152423",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a01Hz",
      "maskType": "none",
      "iconName": "fas/map-location-dot",
      "locked": false
    },
    "7536295121013541694": {
      "type": "frame",
      "id": "7536295121013541694",
      "z": 10646,
      "textContent": "",
      "left": 1762.5412692762416,
      "top": 1679.6402687149373,
      "width": 1110,
      "height": 625,
      "scaleX": 0.5199371001040592,
      "scaleY": 0.1936,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295121011597692",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a239D",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 1,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "bottom"
    },
    "7536295121016841292": {
      "type": "frame",
      "id": "7536295121016841292",
      "z": 10647,
      "textContent": "",
      "left": 2270.6714503917474,
      "top": 1689.6402687149373,
      "width": 1110,
      "height": 625,
      "scaleX": 0.05315315315315315,
      "scaleY": 0.1616,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295121013541694",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a06I0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 3,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295121011959818": {
      "type": "wireframe",
      "id": "7536295121011959818",
      "z": 10648,
      "top": 1699.6402687149373,
      "left": 2281.1714503917474,
      "width": 52,
      "height": 52,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295121016841292",
      "layoutPosition": "a07K7",
      "wireframeName": "avatar",
      "fill": "#A35D4C",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "plus" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": false
    },
    "7536295121006345998": {
      "type": "wireframe",
      "id": "7536295121006345998",
      "z": 10649,
      "top": 1741.6402687149373,
      "left": 2281.1714503917474,
      "width": 52,
      "height": 52,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295121016841292",
      "layoutPosition": "a1BZQ",
      "wireframeName": "avatar",
      "fill": "#A35D4C",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "minus" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": false
    }
  }
}
